import { Report } from '@/shared/api/protocol-ts/model/dto_report_pb';

export const sortReportByDate = (reportA: Report, reportB: Report) =>
  new Date(reportB.Created?.At?.toDate() || 0).getTime() -
  new Date(reportA.Created?.At?.toDate() || 0).getTime();
